import {
  Alert,
  Button,
  CircularProgress,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { useDI } from "@/infrastructure/di/useDI";
import {
    AuthBrand,
  AuthCard,
  AuthContent,
  AuthHeader,
  AuthInfoPanel,
  AuthPage,
} from "../layout";
import { useRequestPasswordResetViewModel } from "./RequestPasswordResetViewModel";

export function RequestPasswordResetPage() {
  const { requestPasswordReset } = useDI();

  const vm = useRequestPasswordResetViewModel({
    requestPasswordReset,
  });

  return (
    <AuthPage>
      <AuthCard>
        <AuthBrand />
        <AuthContent>
          <AuthHeader
            title="Passwort zurücksetzen"
            subtitle="Geben Sie Ihre E-Mail-Adresse ein. Falls ein Konto existiert, senden wir Ihnen einen Link zum Zurücksetzen."
          />

          <Stack spacing={3}>
            {vm.submitState.type === "accepted" ? (
              <Stack spacing={2}>
                <Alert severity="success">
                  Falls ein Konto mit dieser E-Mail-Adresse existiert, wurde ein
                  Link zum Zurücksetzen des Passworts gesendet.
                </Alert>

                <AuthInfoPanel>
                  <Stack spacing={1}>
                    <Typography fontWeight={600}>
                      Prüfen Sie Ihr E-Mail-Postfach
                    </Typography>

                    <Typography variant="body2" color="text.secondary">
                      Der Link ist nur begrenzt gültig. Falls keine E-Mail
                      ankommt, prüfen Sie bitte auch den Spam-Ordner.
                    </Typography>
                  </Stack>
                </AuthInfoPanel>

                <Button
                  component={RouterLink}
                  to="/login"
                  variant="contained"
                  size="large"
                >
                  Zur Anmeldung
                </Button>
              </Stack>
            ) : (
              <Stack
                component="form"
                spacing={3}
                onSubmit={(event) => {
                  event.preventDefault();
                  void vm.actions.submit();
                }}
              >
                {vm.submitState.type === "failed" && (
                  <Alert severity="error">{vm.submitState.message}</Alert>
                )}

                <TextField
                  label="E-Mail-Adresse"
                  type="email"
                  value={vm.values.email}
                  onChange={(event) =>
                    vm.actions.setField("email", event.target.value)
                  }
                  error={Boolean(vm.fieldErrors.email)}
                  helperText={vm.fieldErrors.email}
                  autoComplete="email"
                  fullWidth
                  autoFocus
                />

                <Button
                  type="submit"
                  variant="contained"
                  size="large"
                  disabled={!vm.canSubmit}
                >
                  {vm.submitState.type === "submitting" ? (
                    <Stack direction="row" spacing={1.5} alignItems="center">
                      <CircularProgress size={18} />
                      <span>Link wird gesendet...</span>
                    </Stack>
                  ) : (
                    "Link zum Zurücksetzen senden"
                  )}
                </Button>

                <Button component={RouterLink} to="/login" variant="text">
                  Zurück zur Anmeldung
                </Button>
              </Stack>
            )}
          </Stack>
        </AuthContent>
      </AuthCard>
    </AuthPage>
  );
}
